import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import css from '../assets/css.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.gif';

import profile from '../assets/profile.png';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';

import background1 from '../assets/background-1.jpg'
import background2 from '../assets/background-2.jpg'
import background3 from '../assets/background-3.jpg'
import background4 from '../assets/background-4.jpg'
import background5 from '../assets/background-5.jpg'
import backgroundBlue from '../assets/background-blue.jpg'
import backgroundGreen from '../assets/background-green.jpg'
import backgroundHeader from '../assets/background-header.jpg'
import backgroundPink from '../assets/background-pink.jpg'
import backgroundPinkleaves from '../assets/background-pinkleaves.jpg'
import backgroundMobile from '../assets/background-mobilemenu.jpg'
import backgroundImage from '../assets/background-image.png'
import resume from '../assets/Susritha_Resume.pdf'

import project1 from '../assets/project1.jpg'
import project2 from '../assets/project2.jpg'
import project3 from '../assets/project3.jpg'
import project4 from '../assets/project4.png'

const obj = {
  email,
  mobile,
  api,
  css,
  git,
  html,
  javascript,
  node,
  python,
  react,
  about01,
  about02,
  about03,
  about04,
  profile,
  logo,
  logo2,
  background1,
  background2,
  background3,
  background4,
  background5,
  backgroundBlue,
  backgroundGreen,
  backgroundHeader,
  backgroundPink,
  backgroundPinkleaves,
  backgroundMobile,
  backgroundImage,
  resume,
  project1,
  project2,
  project3,
  project4,
};

export default obj